<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailDemandeImpression.infoGenerale.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('detailDemandeImpression.infoGenerale.dateDemandeImpression')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            {{ demandeImpression.dateDemande | formatDate }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.etat')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            {{ getLibelleEtatDemandeImpression }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.couleur')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-1 is-marginless">
          <span class="has-text-weight-bold">
            {{ getLibellecouleurImpression }}
            <b-icon size="is-small" v-if="getCouleurInformation(demandeImpression.couleur)"
              :custom-class="getCouleurInformation(demandeImpression.couleur).type"
              :icon="getCouleurInformation(demandeImpression.couleur).icon">
            </b-icon>
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.typeOt')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-3 is-marginless">
          <span class="has-text-weight-bold">
            {{ getLibelleTypeOt }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.client')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank
              :to="{
                name: 'c.bodac.clients/contacts-client',
                params: { id: demandeImpression.clientId },
              }"
              class="lien"
              :message="getClientName"/>
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.demandeur')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank
              v-if="demandeImpression.contactDemandeurId"
              :to="{
                name: 'c.bodac.clients/contacts-contacts',
                params: {
                  id: demandeImpression.contactDemandeurId,
                  isFromBailleur: false,
                }
              }"
              class="lien"
              :message="getDemandeurName"/>
          </span>
          <span>&nbsp;{{ emailDemandeur }}</span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.receveur')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank
              v-if="demandeImpression.contactReceveurId"
              :to="{
                name: 'c.bodac.clients/contacts-contacts',
                params: {
                  id: demandeImpression.contactReceveurId,
                  isFromBailleur: false,
                }
              }"
              class="lien"
              :message="getReceveurName"/>
          </span>
          <span>&nbsp;{{ emailReceveur }}</span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.soldeStock')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-2 is-marginless">
          <span class="has-text-weight-bold">
            {{ demandeImpression.soldeStock }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.quantite')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-2 is-marginless">
          <span class="has-text-weight-bold">
            {{ demandeImpression.quantite }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.dateLimite')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            {{ demandeImpression.dateLimite | formatDate }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.nomVariante')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span class="has-text-weight-bold">
            {{ demandeImpression.nomVariante }}
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.nomFichierRip')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          {{ demandeImpression.nomFichierRip }}
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.graphisteEnCharge')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <router-link-blank
            v-if="demandeImpression.graphisteEnChargeId"
            :to="{
              name: 'c.parametrage.collaborateurs',
              params: { id: demandeImpression.graphisteEnChargeId },
            }"
            class="lien"
            :message="getUser(demandeImpression.graphisteEnChargeId)"/>
        </b-field>
        <b-field
          v-if="!!demandeImpression.devisCommandes"
          :label="$t('detailDemandeImpression.infoGenerale.OTs')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <span
            v-for="(devisCommande, index) in demandeImpression.devisCommandes"
            :key="devisCommande.id"
            class="has-text-weight-bold">
            <router-link-blank
              :to="{
                name: 'c.logistique.ordre_travail-tech',
                params: { id: devisCommande.id },
              }"
              class="lien"
              :message="devisCommande.code"/>
            <span v-if="index != demandeImpression.devisCommandes.length - 1">, </span>
          </span>
        </b-field>
        <b-field :label="$t('detailDemandeImpression.infoGenerale.tags')"
          custom-class="has-text-weight-normal is-italic is-marginless"
          class="column is-4 is-marginless">
          <query-tags-tag-input class="mgt-2px"
            v-model="demandeImpression.tags"
            field="tag"
            is-detail>
          </query-tags-tag-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import {
  ETAT_DEMANDE_IMPRESSION,
  COULEUR_IMPRESSION,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
  components: {
    RouterLinkBlank,
    queryTagsTagInput,
  },
  data() {
    return {
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        COULEUR_IMPRESSION,
      },
      infoPopUpPrevention: {
        title: '',
        sousTitle: '',
      },
      etatSelect: null,
      popUpPrevention: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getLibelleEtatDemandeImpression() {
      const etatDemandeImpression = this.constantes.ETAT_DEMANDE_IMPRESSION.find((etat) => {
        return etat.key === this.demandeImpression.etat;
      });
      return this.$t(etatDemandeImpression.libelle);
    },
    getLibellecouleurImpression() {
      const couleurImpression = this.constantes.COULEUR_IMPRESSION
        .find((couleur) => {
          return couleur.key === this.demandeImpression.couleur;
        });
      return couleurImpression ? this.$t(couleurImpression.libelle) : '';
    },
    getLibelleTypeOt() {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === this.demandeImpression.typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getClientName() {
      return this.demandeImpression.client.nomCommercial;
    },
    getDemandeurName() {
      const nom = this.demandeImpression.contactDemandeur
        ? this.demandeImpression.contactDemandeur.nom : '';
      const prenom = this.demandeImpression.contactDemandeur
        ? this.demandeImpression.contactDemandeur.prenom : '';
      return `${prenom} ${nom}`.trim();
    },
    getReceveurName() {
      const nom = this.demandeImpression.contactReceveur
        ? this.demandeImpression.contactReceveur.nom : '';
      const prenom = this.demandeImpression.contactReceveur
        ? this.demandeImpression.contactReceveur.prenom : '';
      return `${prenom} ${nom}`.trim();
    },
    getCamapgneLibelle() {
      return this.demandeImpression.campagne?.libelle;
    },
    emailDemandeur() {
      return this.demandeImpression.contactDemandeur?.email ?? '';
    },
    emailReceveur() {
      return this.demandeImpression.contactReceveur?.email ?? '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    getCouleurInformation(couleur) {
      return this.constantes.COULEUR_IMPRESSION.find(
        (couleurImpression) => couleur === couleurImpression.key,
      );
    },
    getUser(userId) {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => { return user.id === userId; });
      if (!userFound) return '';
      return nomPrenomGetter(userFound);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style>

</style>
